import api from './api';

const authService = {
  // Register or login with Telegram
  register: async (initData, phoneNumber) => {
    const response = await api.post('/auth/register', {
      initData,
      phone_number: phoneNumber,
    });
    return response.data;
  },

  // Verify token
  verify: async () => {
    const response = await api.get('/auth/verify');
    return response.data;
  },

  // Login with Telegram
  login: async (initData) => {
    const response = await api.post('/auth/login', { initData });
    return response.data;
  },

  // Login with username/password
  loginWithPassword: async (username, password) => {
    const response = await api.post('/auth/login-password', { username, password });
    return response.data;
  },

  // Register with username/password (for guests)
  registerWithPassword: async (username, password, phone_number, first_name, last_name) => {
    const response = await api.post('/auth/register-password', {
      username,
      password,
      phone_number,
      first_name,
      last_name,
    });
    return response.data;
  },

  // Logout
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },
};

export default authService;
